import { getController } from '@/services/service'

const url = 'meter_types'

export const meterTypeService = {
	...getController<Api.Type, Api.TypeUpdateInput, Api.TypeUpdateInput>(url),
}

export default meterTypeService
